export default {
 apolloClient: undefined,
 defaultCurrency: undefined
}